// setTimeout(function () {
//  var languageName = $('.transcy-locale-name.transcy-language-locale-name').html();
//  var languageGerman = "German"
//  console.log("timeup");
//  console.log(languageName);
//  console.log(languageGerman);
//  if (languageName == languageGerman ) {
//   console.log("Yes, its German")
//   $(document).ready(function () {
//    $('.flexified-child.yotpo-outer-tile[aria-label="PointsForPurchasesCampaign"] .yotpo-title-text').html("1 Punkt pro 1,00 €");
//   });
//  }
// }, 5000);

 

$(document).ready(function() {
  const myAccount = {
    sl: 'Moj račun',
    'sl-SI': 'Moj račun',
    hr: 'Moj račun',
    hu: 'A fiókom',
    en: 'My account',
    de: 'Mein Konto',
  }

  const accountSettings = {
    sl: 'Nastavitve računa',
    'sl-SI': 'Nastavitve računa',
    hr: 'Postavke računa',
    hu: 'Fiók beállítások',
    en: 'Account Settings',
    de: 'Account Einstellungen, ' 
  }

  const customerService = {
    sl: 'Pomoč strankam',
    'sl-SI': 'Pomoč strankam',
    hr: 'Korisnička podrška',
    hu: 'Vevőszolgálat',
    en: 'Customer Service',
    de: 'Kundendienst', 
  }

  
 var headingOne = `<span class="frcp-nav-button slfe-heading"><span class="frcp-nav-button__text">${myAccount[Shopify.locale]}</span></span>`;
 var headingTwo = `<span class="frcp-nav-button slfe-heading"><span class="frcp-nav-button__text">${accountSettings[Shopify.locale]}</span></span>`;
 var headingThree = `<span class="frcp-nav-button slfe-heading"><span class="frcp-nav-button__text">${customerService[Shopify.locale]}</span></span>`;
 var headingEmpty = '<span class="frcp-nav-button slfe-heading"><span class="frcp-nav-button__text"></span></span>';
 var headingBorder = '<span class="frcp-nav-button slfe-heading"><span class="frcp-nav-button__text border"></span></span>';
 $('.frcp-nav__menu span[data-to="#/orders"]').before(headingOne);
 $('.frcp-nav__menu span[data-to="#/profile"]').before(headingBorder + headingTwo);
 $('.frcp-nav__menu span[data-to="#/contact-us"]').before(headingBorder + headingThree);
 $('.frcp-nav__menu span[aria-label="Logout"]').before(headingBorder);
});
